import React from 'react';
import RequestWizardActions from './RequestWizardActions';
import RequestSummaryActions from './RequestSummaryActions';
import RequestMarkdownActions from '../markdown/components/RequestMarkdownActions';
import Selectors from '../hooks/selectors';

const RequestActions = ({ category, code }) => {
  const { isNew, isOrphanedByDataset } = Selectors.useRequestActions({ category, code });
  return (
    <>
      {isNew && (<RequestWizardActions category={category} code={code} />)}
      {isOrphanedByDataset && (<RequestMarkdownActions category={category} code={code} isOrphanedByDataset />)}
      {!isNew && !isOrphanedByDataset && (<RequestSummaryActions category={category} code={code} />)}
    </>
  );
};

export default RequestActions;
